import { ActionTypes } from './constants'

const initialState = {
    graphData: [],
    graphRendering: false,
    selectedParams: [],
    listParams: [],
};

const CompareGraphReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_GRAPH_DATA:
            return { ...state, graphData: payload }
        case ActionTypes.SET_SELECTED_PARAMS:
            return { ...state, selectedParams: payload }
        case ActionTypes.SET_GRAPH_RENDERING:
            return { ...state, graphRendering: payload }
        case ActionTypes.ADD_SELECTED_PARAMS:
            return {...state, selectedParams:[...state.selectedParams, payload]}
        case ActionTypes.DELETE_SELECTED_PARAMS:
            return {...state, selectedParams: state.selectedParams.filter(i => i.id != payload.id)}
        case ActionTypes.SET_LIST_PARAMS:
            return { ...state, listParams: payload }
        case ActionTypes.SET_VISIBLE:
            return { ...state, graphData: state.graphData.map((item, i) => { return item.name == payload.name ? { ...item, onGraph: payload.visible } : item }) }
        default:
            return state;
    }
};

export default CompareGraphReducer;